import { render } from "./TerminoYCondiciones.vue?vue&type=template&id=460b6295"
import script from "./TerminoYCondiciones.vue?vue&type=script&lang=js"
export * from "./TerminoYCondiciones.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__